<template>
  <aside>
    <h3>{{ $t('advert.detail.metadata.period') }}</h3>
    <p>{{ availability }}</p>
  </aside>
</template>

<script>
export default {
  name: 'Availability',
  props: {
    availability: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "src/assets/style/advertMetaData";
</style>
